import { render, staticRenderFns } from "./userPropertyFilter.vue?vue&type=template&id=8272d0ae&"
import script from "./userPropertyFilter.vue?vue&type=script&lang=js&"
export * from "./userPropertyFilter.vue?vue&type=script&lang=js&"
import style0 from "./userPropertyFilter.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports